import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { BsFilter } from 'react-icons/bs';
import { dispatch, useGlobalState } from '../../store/state';
import { Button, message, Pagination, Radio, Select } from 'antd';
import { Config } from '../../Config';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import { CampaignSelectLists } from '../../apis/Brand/Campaigns/CampaignSelectLists';
// import { GetInfluencers } from '../../apis/Brand/Discovery/GetInfluencers';
import EmptyInfluencerComponent from '../../components/Admin/Influencers/EmptyInfluencerComponent';
import InfluencerCardComponent from '../../components/Admin/Influencers/InfluencerCardComponent';
import { GetAllInfluencers } from '../../apis/Admin/Influencers/GetAllInfluencers';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
// import { GetPendingInfluencers } from '../../apis/Admin/Influencers/GetPendingInfluencers';
import { IoIosArrowBack } from 'react-icons/io';
import { GetInfluencer } from '../../apis/Admin/Influencers/GetInfluencer';
import ProfileBasicComponent from '../../components/Admin/Influencers/ProfileBasicComponent';
import ProfileEarnStatsComponent from '../../components/Admin/Influencers/ProfileEarnStatsComponent';
import ProfileAboutComponent from '../../components/Admin/Influencers/ProfileAboutComponent';
import ProfileBankComponent from '../../components/Admin/Influencers/ProfileBankComponent';
import { ApproveInfluecner } from '../../apis/Admin/Influencers/ApproveInfluecner';

const { Option } = Select;
export const AdminInfluencersDetailPage = () => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [loading, setLoading] = useState(true);

  const [influData, setInfluData]= useState({});

  const fetchInfluencer = () =>{
    GetInfluencer(user.accessToken, params.influencerId).then(({ status, response })=>{
      console.log('Influencer Data', response);
      if (status === 200) {
        setInfluData({
          ...influData,
          ...response,
        });
        setLoading(false);
      } else {
        message.error('There some issue whiling getting this Influencer');
        console.log('Failed to fetch Influencers List', response);
      }
    });
  };


  useEffect(() => {
    fetchInfluencer();
  }, []);

  const approval = () =>{
    ApproveInfluecner(user.accessToken, params.influencerId).then(({ status, response })=>{
      console.log('approval influcners', response);
      if (status === 200) {
        message.success('Influencer Approved Successfully!');
        fetchInfluencer();
      } else {
        message.error('There is some issue while Approving influencer');
      }
    });
  };


  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="px-3 py-2 sticky">
        <div className="row">
          <div className="col-md-4">
            <Link className="common_button p-1 d-inline-block mr-2"
              to="/admin/dashboard/influencers/"><IoIosArrowBack size={20}/></Link>
            <span><strong>Influencer Profile</strong></span>
          </div>
          <div className="col-md-8 text-right">
            {!influData.verified?(
              <>
                <Button className="common_button py-1"
                  onClick={approval}>Approve</Button>
                <Button className="common_button outlined ml-2 py-1"
                  disabled>Reject</Button>
              </>
            ):null
            }
          </div>
        </div>
      </TopSubHeaderComponent>
      <div className="d-flex flex-wrap px-2">
        <ProfileBasicComponent
          loading={loading}
          picture={influData.picture || influData.profilepicture}
          firstname={influData.firstname}
          lastname={influData.lastname}
          gender={influData.gender}
          id={influData.id}
          city_living={influData.city_living}
          interests={influData.interests}
          youtube_account={influData.youtube_account}
          twitter_account={influData.twitter_account}
          instagram_account={influData.instagram_account}
        />
        <ProfileEarnStatsComponent
          loading={loading}
          platformData={{
            youtube: influData.youtube_account,
            twitter: influData.twitter_account,
            instagram: influData.instagram_account,
          }}
        />
        {/* camp stats */}
        <ProfileAboutComponent loading={loading}
          profile={influData}/>
        {/* bank Details */}
        <ProfileBankComponent/>
      </div>
    </BaseLayoutComponent>
  );
};
